import $ from 'jquery'

import CommonDataLayer from '../../common.blocks/data-layer'

export default class DataLayer extends CommonDataLayer {
	static title = 'data-layer'

	constructor($el) {
		super($el)

		$(document).on('click', '[data-track]', (event) => {
			const $target = $(event.currentTarget)

			this.pushEvent({
				event: 'cta_click',
				cta_group: $target.data('track'),
				cta_label: $target.data('trackLabel'),
			})
		})

		$(document).on('callback:lead', (event, data) => {
			this.pushEvent({
				event: 'generate_lead',
				lead_type: 'callback',
				lead_source: data.source,
				form_id: data.formId,
			})
		})
	}

	// unlike the ecommerce events these do not depend on the ga4 page data
	pushEvent(payload) {
		window.dataLayer = window.dataLayer || []
		this.push(payload)
	}
}
